var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDot2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 20,
    viewBox: "0 0 13 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2948 1.69971C15.2765 5.72887 10.5984 11.0941 5.00857 17.8608C4.2732 18.5839 2.98485 19.7484 3.71449 18.622C4.62653 17.2139 2.72861 13.9845 1.09246 9.72618C-0.543686 5.46783 5.31319 -2.32945 10.2948 1.69971Z",
    fill: "#487E6F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDot2);
export default __webpack_public_path__ + "static/media/dot2.f7f73e6d3195fd70f942b93b0adf34a1.svg";
export { ForwardRef as ReactComponent };